import React from "react";
import { Route } from "react-router-dom";
import Login from "../components/login/Login";
import Dashboard from "../components/dashboard/Dashboard";
import Layout from "../components/layout/Layout";
import RegisterMachine from "../components/machine/RegisterMachine";
import MachineOverview from "../components/machine/MachineOverview";
import RegisterCustomer from "../components/customer/RegisterCustomer";
import CustomerOverview from "../components/customer/CustomerOverview";
import RegisterDealer from "../components/dealer/RegisterDealer";
import DealerOverview from "../components/dealer/DealerOverview";
import AllTrackers from "../components/tracker/AllTrackers";
import MapComponent from "../components/tracker/map/LiveTracker";
import ManufacturerRegistration from "../components/manufacturer/ManufacturerRegistration";
import ManufacturerOverview from "../components/manufacturer/ManufacturerOverview";
import RegisterDevice from "../components/machine/RegisterDevice";
import RegisterSIM from "../components/machine/RegisterSIM";
import AssignMachineToDealer from "../components/machine/AssignMachineToDealer";
import AssignMachineToCustomer from "../components/machine/AssignMachineToCustomer";

const routes = [
  {
    path: "/",
    exact: true,
    component: Login,
  },
  {
    path: "/dashboard",
    render: () => (
      <Layout>
        <Dashboard />
      </Layout>
    ),
  },
  {
    path: "/machines",
    render: () => (
      <Layout>
        <div>Machines</div>
      </Layout>
    ),
  },
  {
    path: "/users",
    render: () => (
      <Layout>
        <div>Users</div>
      </Layout>
    ),
  },
  {
    path: "/dealers",
    render: () => (
      <Layout>
        <div>Dealers</div>
      </Layout>
    ),
  },
  {
    path: "/schemes",
    render: () => (
      <Layout>
        <div>Schemes</div>
      </Layout>
    ),
  },
  {
    path: "/apply",
    render: () => (
      <Layout>
        <div>Apply</div>
      </Layout>
    ),
  },
  {
    path: "/live-tracking",
    render: () => (
      <Layout>
        <MapComponent />
      </Layout>
    ),
  },
  {
    path: "/all-trackers",
    render: () => (
      <Layout>
        <AllTrackers />
      </Layout>
    ),
  },
  {
    path: "/register-machine",
    render: () => (
      <Layout>
        <RegisterMachine />
      </Layout>
    ),
  },
  {
    path: "/machine-overview",
    render: () => (
      <Layout>
        <MachineOverview />
      </Layout>
    ),
  },
  {
    path: "/assign-machine-to-dealer",
    render: () => (
      <Layout>
        <AssignMachineToDealer />
      </Layout>
    ),
  },
  {
    path: "/assign-machine-to-customer",
    render: () => (
      <Layout>
        <AssignMachineToCustomer />
      </Layout>
    ),
  },
  {
    path: "/register-customer",
    render: () => (
      <Layout>
        <RegisterCustomer />
      </Layout>
    ),
  },
  {
    path: "/customer-overview",
    render: () => (
      <Layout>
        <CustomerOverview />
      </Layout>
    ),
  },
  {
    path: "/register-dealer",
    render: () => (
      <Layout>
        <RegisterDealer />
      </Layout>
    ),
  },
  {
    path: "/dealer-overview",
    render: () => (
      <Layout>
        <DealerOverview />
      </Layout>
    ),
  },
  {
    path: "/register-manufacturer",
    render: () => (
      <Layout>
        <ManufacturerRegistration />
      </Layout>
    ),
  },
  {
    path: "/manufacturer-overview",
    render: () => (
      <Layout>
        <ManufacturerOverview />
      </Layout>
    ),
  },
  {
    path: "/register-device",
    render: () => (
      <Layout>
        <RegisterDevice />
      </Layout>
    ),
  },
  {
    path: "/register-sim",
    render: () => (
      <Layout>
        <RegisterSIM />
      </Layout>
    ),
  },
];

export default routes;
